module.exports = __webpack_public_path__ + "static/media/id_flag.1b9520d7.svg";